var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2167_2180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2167_2180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60579 19.7083C4.93984 19.7083 4.37372 19.4769 3.90744 19.0142C3.44131 18.5514 3.20825 17.9895 3.20825 17.3284V4.6892C3.20825 4.02324 3.44131 3.45712 3.90744 2.99084C4.37372 2.52472 4.93984 2.29166 5.60579 2.29166H15.407V16.3238H5.60579C5.32254 16.3238 5.08131 16.4199 4.88209 16.6121C4.68286 16.8044 4.58325 17.0427 4.58325 17.3271C4.58325 17.6112 4.68286 17.85 4.88209 18.0434C5.08131 18.2367 5.32254 18.3333 5.60579 18.3333H17.4166V4.12499H18.7916V19.7083H5.60579ZM7.96781 14.9488H14.032V3.66666H7.96781V14.9488ZM6.59281 14.9488V3.66666H5.60579C5.31597 3.66666 5.07313 3.76627 4.87727 3.96549C4.68126 4.16471 4.58325 4.40595 4.58325 4.6892V15.2148C4.74184 15.1397 4.90393 15.0765 5.06954 15.0253C5.23515 14.9743 5.4139 14.9488 5.60579 14.9488H6.59281Z",
    fill: "#155DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook4);
export default __webpack_public_path__ + "static/media/book_4.65fbf423a4182fb345bb5264b94fa8c1.svg";
export { ForwardRef as ReactComponent };